import { stringifyQs } from "@saleor/utils/urls";

import { SingleAction } from "../types";

const recommendPopupSection = "/recommendPopup/";
export const recommendPopupPath = recommendPopupSection;
export type RecommendPopupUrlQueryParams = SingleAction;

export const recommendPopupUrl = (params?: RecommendPopupUrlQueryParams) =>
  recommendPopupSection + "?" + stringifyQs(params);
